<template>
  <div class="app-inner">
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">模板名称</p>
        <el-input v-model="temName" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <!-- <div class="stateDiv">
        <p class="searchText">所属楼宇</p>
        <el-select v-model="buildingId" placeholder="请输入" clearable class="inputDiv">
          <el-option v-for="item in buildingValueList" :key="item.buildingId" :label="item.buildingName"
            :value="item.buildingId"></el-option>
        </el-select>
      </div> -->
      <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
      <el-button v-if="roleName === '招商经理' || roleName === '招商员' || roleName === '管理员'" class="searchBtn" type="warning"
        @click="addTem">新增模板
      </el-button>
    </div>
    <!--      列表-->
    <div class="table">
      <div class="searchList">
        <el-table v-loading="loading" :data="tableData" :default-sort="{prop: 'id', order: 'descending'}"
          style="width: 100%" :highlight-current-row="false"
          :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
          <template v-for="(item, index) in tableColumns">
            <el-table-column v-if="item.prop === 'buildingId'" :key="index" :prop="item.prop" :label="item.label"
              :width="item.width">
              <template slot-scope="scope">
                <div>
                  {{ getNameById(scope.row.buildingId) || '--' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column v-else :key="index" :prop="item.prop" :label="item.label" :formatter="item.formatter"
              :width="item.width"></el-table-column>
          </template>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope" class="tableButton">
              <el-button class="tableBtn" @click="previewFun(scope.row)" type="text" size="small">预览</el-button>
              <el-button v-if="roleName === '招商经理' || roleName === '招商员' || roleName === '管理员'" class="tableBtn"
                @click="editFun(scope.row)" type="text" size="small">编辑
              </el-button>
              <el-button v-if="roleName === '招商经理' || roleName === '招商员' || roleName === '管理员'" class="tableBtn"
                @click="deleteFun(scope.row)" type="text" size="small">删除
              </el-button>
              <el-button class="tableBtn" @click="download(scope.row)" type="text" size="small">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="totalCount" class="paginationBody"></el-pagination>
    </div>
    <!--    预览模板时内容弹框-->
    <div class="previewDialogDiv">
      <el-dialog :visible.sync="previewVisible" center>
        <p class="ql-editor" v-html="content"></p>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import { listBuildingInfos } from '@/api/searchList'
import { tempQuery, deleteTemp, downloadTemp, editTemp } from '@/api/contract'
import base from '@/utils/index'

export default {
  name: 'templatePage',
  data () {
    return {
      loading: false,
      roleName: '',
      content: '',
      roleValue: '',
      roleValueList: [],
      companyValueList: [],
      stateValue: '',
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      dialogFormVisible: false,
      previewVisible: false,
      eventControl: '',
      temName: '',
      companyAddress: '',
      buildingId: '',
      buildingValueList: [],
      addForm: {
        name: '',
        address: '',
        bank: '',
        account: ''
      },
      rules: {
        name: [{ required: true, message: '请填写', trigger: 'blur' }],
        address: [{ required: true, message: '请填写', trigger: 'blur' }],
        bank: [{ required: true, message: '请填写', trigger: 'blur' }],
        account: [{ required: true, message: '请填写', trigger: 'blur' }]
      },
      tableData: [],
      tableColumns: [
        {
          prop: 'templateNumber',
          label: '模板编号'
        },
        {
          prop: 'templateName',
          label: '模板名称'
        },
        // {
        //   prop: 'buildingId',
        //   label: '所属楼宇',
        //   formatter: (row, column, v) => {
        //     return this.buildingValueList.find(v2 => v2.buildingId === v).buildingName
        //   }
        // },
        {
          prop: 'remark',
          label: '备注'
        }
      ]
    }
  },
  mounted () {
    const baseFunc = base()
    this.roleName = baseFunc.getLocalStorage('userInfo_roleName')
    // this.getBuildingList()
    this.getData()
  },
  methods: {
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryList()
    },
    // 新增模板
    addTem () {
      this.$router.push({
        path: '/contract/addTemplate',
        query: {
          isEdit: false
        }
      })
    },
    // 所属楼宇下拉框
    // async getBuildingList () {
    //   let res = await listBuildingInfos({})
    //   if (res.code === 0) {
    //     this.buildingValueList = res.result
    //   }
    // },
    // 查询
    getData () {
      this.currentPage = 1
      this.queryList()
    },
    async queryList () {
      let res = await tempQuery({
        buildingId: this.buildingId,
        templateName: this.temName,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === 0) {
        this.tableData = res.result.records
        this.totalCount = res.result.total
      }
    },
    // 编辑模板
    editFun (row) {
      this.$router.push({
        path: '/contract/addTemplate',
        query: {
          isEdit: true,
          id: row.id
        }
      })
    },
    async previewFun (row) {
      let res = await editTemp({
        id: row.id
      })
      if (res.code === 0) {
        this.previewVisible = true
        this.content = res.result.textContent
      }
      // this.$router.push({
      //   path: '/contract/previewTemplate',
      //   query: {
      //     id: row.id
      //   }
      // })
    },
    // 删除模板
    async deleteFun (row) {
      this.$confirm('此操作将删除该模板, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(
        async () => {
          let params = {
            'id': row.id
          }
          let res = await deleteTemp(params)
          if (res.code === 0) {
            this.$message.success('删除成功！')
          }
          await this.queryList()
        }
      )
    },
    // 下载模板
    async download (row) {
      let res = await downloadTemp({
        'id': row.id
      })
      const elink = document.createElement('a')
      elink.download = row.templateName + '.pdf'
      elink.style.display = 'none'
      const blob = new Blob([res])
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      document.body.removeChild(elink)
    },
    getNameById (id) {
      let result
      for (let i of this.buildingValueList) {
        if (i.buildingId === id) {
          result = i.buildingName
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.app-inner {
  width: 98%;
  height: 70vh;
  padding: 0.2rem;
  box-sizing: border-box;
}
.searchTitleDiv {
  width: 15rem;
  height: 0.66rem;
  margin-left: 0.2rem;
  margin-top: 0.05rem;
  /*display: flex;*/
  /*justify-content: space-around;*/
  .stateDiv {
    margin-top: 0.14rem;
    margin-left: .3rem;
    float: left;
  }
  .searchText {
    margin-top: 0.05rem;
    margin-right: 0.13rem;
    font-size: 0.2rem;
    color: #111111;
    float: left;
  }
  .inputDiv {
    width: 2.2rem;
    float: left;
  }
  .searchBtn {
    /*width: 1.20rem;*/
    /*height: 0.36rem;*/
    /*border-radius: 0.06rem;*/
    /*font-size: 0.18rem;*/
    margin-top: 0.14rem;
    margin-left: .3rem;
    /*padding-top: 0.1rem;*/
  }
}
.table {
  margin-top: .3rem;
  margin-left: .5rem;
  text-align: center;
  width: 14.8rem;
  .searchList {
  }
  .paginationBody {
    margin-top: .1rem;
  }
}
.formItem {
  width: 3.2rem;
}
/deep/ .el-dialog {
  width: 23% !important;
}
.previewDialogDiv {
  /deep/ .el-dialog {
    width: 50% !important;
  }
}
</style>
